module.exports = __webpack_public_path__ + "img/Twitter Icon.a9031381.svg";